import {
  getSelectedSchool,
  getSelectedSport,
  selectSeeAllScoresButton,
} from 'app/imports/App.selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useSchedulesLink } from '../../hooks/useSchedulesLink'
import { useScoresLink } from '../../hooks/useScoresLink'
import * as Styled from './GamesScoresButton.styled'

export function GamesScoresButton() {
  const seeAllScoresButton = useSelector(selectSeeAllScoresButton)
  const school = useSelector(getSelectedSchool)
  const selectedSport = useSelector(getSelectedSport)

  const sportIds =
    selectedSport && selectedSport.length > 0
      ? selectedSport.map((sportItem) => sportItem.id)
      : undefined

  const { scoresUrl } = useScoresLink(sportIds)
  const { schedulesUrl } = useSchedulesLink()

  const buttonTitle = useMemo(() => {
    if (school && school.length === 1) {
      return `${school[0].shortName || school[0].name} Hub`
    }

    return 'See All Scores'
  }, [school])

  if (!seeAllScoresButton) {
    return null
  }

  return (
    <Styled.ButtonContainer
      href={school && school.length === 1 ? schedulesUrl : scoresUrl}
      target="_blank"
    >
      <Styled.Button type="button">{buttonTitle}</Styled.Button>
    </Styled.ButtonContainer>
  )
}
